import { createSelector } from 'reselect'

const getAuth = (state) =>  state.auth

export const getSelectorAuth = createSelector(
  [ getAuth ],
  (auth) => auth
)


// WEBPACK FOOTER //
// ./src/modules/auth/AuthSelectors.js